/**
 * @param {string} dataName - the name of the data to be spread to pages
 * @param {string} effectingHtmlElements - the name of the html elements' array to insert data
 * @return {string} - the pagination code
 */
export const paginationCodeTemplate = (dataName, effectingArrayOfHtmlElements, compId) => `
  let numberOfPages = Math.ceil(${dataName}.length/${effectingArrayOfHtmlElements}.length);
  let pagination = document.getElementById("${compId}").querySelector('[pagination-list="true"]');

    let paginationAttributes = [
      "pagination-first",
      "pagination-last",
      "pagination-previous",
      "pagination-next",
    ];

    for (let i = 0; i < pagination.children.length; ) {
      let foundAttr = false;

      paginationAttributes.forEach((attr) => {
        if (pagination.children[i].attributes.getNamedItem(attr) !== null) {
          foundAttr = true;
        }
      });
      if (foundAttr === false) {
        pagination.removeChild(pagination.children[i]);
      } else {
        i++;
      }
    }

    for (let i = 0; i < numberOfPages; i++) {
      let child = document.createElement("li");
      child.classList.add("page-item");
      if (i === numberOfPages - 1) {
        child.classList.add("active");
      }
      let insideChild = document.createElement("a");
      insideChild.classList.add("page-link");
      let textnode = document.createTextNode(numberOfPages - i);
      insideChild.appendChild(textnode);
      insideChild.setAttribute("href", "#!");
      child.appendChild(insideChild);
      child.onclick = function () {
        if (chunk !== numberOfPages - i) {
          chunk = numberOfPages - i;
          onClickPaginationButton${compId}(chunk, pagination);
        }
      };

      let numberOfFrontButtons =  findTypeOfPagination${compId}(pagination);
      pagination.insertBefore(child, pagination.children[numberOfFrontButtons]);

    }

    for (let i = 0; i < pagination.children.length; i++) {
      let child = pagination.children[i];
      if ( child.getAttribute("pagination-first") === "true" && numberOfPages > 0 ) {
        child.onclick = function () {
          if(chunk !== 1){
            chunk = 1;
            onClickPaginationButton${compId}(1, pagination);
          }
        };
      }

      if ( child.getAttribute( "pagination-last" ) === "true" && numberOfPages > 0 ) {
        child.onclick = function () {
          if(chunk !== numberOfPages){
            chunk = numberOfPages;
            onClickPaginationButton${compId}( numberOfPages, pagination);
          }
        };
      }

      if ( child.getAttribute("pagination-previous") === "true" && numberOfPages > 0 ) {
        child.onclick = function () {
          if(chunk !== returnChunkIndex${compId}(chunk,numberOfPages,'-')){
            chunk = returnChunkIndex${compId}(chunk,numberOfPages,'-');
            onClickPaginationButton${compId}(chunk, pagination);
          }
        };
      }

      if ( child.getAttribute("pagination-next") === "true" && numberOfPages > 0) {
        child.onclick = function () {
          if(chunk !== returnChunkIndex${compId}(chunk,numberOfPages,'+')){
            chunk = returnChunkIndex${compId}(chunk,numberOfPages,'+');
            onClickPaginationButton${compId}(chunk, pagination);
          }
        };
      }
    };`;

/**
 * The pagination label to insert the code
 */
export const paginationCodeLabel = `<paginationCode>`;

export default { paginationCodeTemplate, paginationCodeLabel };
